import { render, staticRenderFns } from "./SellerDetail.vue?vue&type=template&id=379352ba&scoped=true"
import script from "./SellerDetail.vue?vue&type=script&lang=js"
export * from "./SellerDetail.vue?vue&type=script&lang=js"
import style0 from "./SellerDetail.vue?vue&type=style&index=0&id=379352ba&prod&lang=css"
import style1 from "./SellerDetail.vue?vue&type=style&index=1&id=379352ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379352ba",
  null
  
)

export default component.exports